import R from 'ramda'

const FACEBOOK_RECURRING_OPTOUT_DISPLAY_TYPE = 'Opt FB User out - Recurring'
const FACEBOOK_RECURRING_OPTOUT_WIDGET_TYPE = 'FB_OPT_OUT_RECURRING'

const isFacebookRecurringWidgetOptOutAction = R.propEq(
  'type',
  FACEBOOK_RECURRING_OPTOUT_WIDGET_TYPE
)

const isPlainTextResponse = R.pipe(
  R.prop('success'),
  R.head,
  R.pathSatisfies(R.complement(R.either(R.isNil, R.isEmpty)), [
    'message',
    'message',
    'text'
  ])
)

const constructPlainTextResponse = R.path([
  'success',
  0,
  'message',
  'message',
  'text'
])

const constructTemplateResponse = R.pipe(
  R.prop('success'),
  R.head,
  R.path([
    'message',
    'message',
    'attachment',
    'payload',
    'elements',
    0,
    'subtitle'
  ])
)

const constructGenericTemplateAction = R.applySpec({
  type: R.always(FACEBOOK_RECURRING_OPTOUT_DISPLAY_TYPE),
  action: R.always('TEMPLATE_GENERIC'),
  fbOptOutRecurringAutoResponseText: R.cond([
    [isPlainTextResponse, constructPlainTextResponse],
    [R.T, constructTemplateResponse]
  ]),
  fbOptOutRecurringAutoResponseImageUrl: R.pipe(
    R.prop('success'),
    R.head,
    R.pathOr('', [
      'message',
      'message',
      'attachment',
      'payload',
      'elements',
      0,
      'image_url'
    ])
  ),
  templateTitle: R.pipe(
    R.prop('success'),
    R.head,
    R.pathOr('', [
      'message',
      'message',
      'attachment',
      'payload',
      'elements',
      0,
      'title'
    ])
  ),
  templateActionUrl: R.pipe(
    R.prop('success'),
    R.head,
    R.pathOr('', [
      'message',
      'message',
      'attachment',
      'payload',
      'elements',
      0,
      'default_action',
      'url'
    ])
  )
})

const constructCustomTemplateAction = R.applySpec({
  type: R.always(FACEBOOK_RECURRING_OPTOUT_DISPLAY_TYPE),
  customDmTemplate: R.pipe(
    R.pipe(
      R.prop('success'),
      R.head,
      R.prop('message'),
      R.applySpec({ message: R.prop('message') })
    ),
    JSON.stringify
  ),
  action: R.always('TEMPLATE_CUSTOM')
})

const convertFacebookRecurringOptOutToFormAction = R.cond([
  [
    R.pathSatisfies(R.equals(true), ['success', 0, 'isCustomTemplate']),
    constructCustomTemplateAction
  ],
  [R.T, constructGenericTemplateAction]
])

export {
  isFacebookRecurringWidgetOptOutAction,
  convertFacebookRecurringOptOutToFormAction
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/facebook/widget-to-form/facebook-recurring-optout.js